import React,{useRef,useState,useEffect,useCallback} from 'react';
import axios from 'axios';
import Papa from 'papaparse';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ListItem from '@mui/material/ListItem';
import Container from '@mui/material/Container';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Fab from '@mui/material/Fab';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import CreateIcon from '@mui/icons-material/Create';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import { Grid,TextField,Button } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { createTheme } from "@mui/material";
import Paper from '@mui/material/Paper';
import {ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import ListItemText from '@mui/material/ListItemText';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
const drawerWidth = 300;
const materialTheme = createTheme({
  // set default for now
});


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
   
    appBarReviewOrder: {
      position: 'fixed',
    },
    appBarBottomReviewOrder: {
      top: 'auto',
      bottom: 0
    },
    titleBarReviewOrder: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    appBarTop: {
        [theme.breakpoints.up('sm')]: {
          width: `calc(100% - ${drawerWidth}px)`,
          marginLeft: drawerWidth,
        },
      },
      menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
          display: 'none',
        },
      },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBarBottom: {
    top: 'auto',
    bottom: 0,
    [theme.breakpoints.up('sm')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
 

}));

function MultipleAccountPricings(props){
  const classes = useStyles();

  const elementRef = useRef(null);
  const [, setAppBarWidth] = useState(0);
  const [loadSchemes, setLoadSchemes] = useState(true);
  const [searchSchemeTerm, setSearchSchemeTerm] = useState({name:""});
  const [isLoading, setIsLoading] = useState(true);
  const [,setHasErrorFetchingSchemes] = useState(false); 
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMoreSchemeToLoad,setHasMoreSchemeToLoad] = useState(true);
  const [schemes,setSchemes] = useState([]);
  const [autoCompleteSearchOptionMessage,setAutoCompleteSearchOptionMessage] = useState("Searching...")
  const [autoSuggestSchemes,setAutoSuggestSchemes] = useState([])
  
  //Assignment Template
  const [showCsvDownloadAssignments,setShowCsvDownloadAssignments] = useState(false)
  const [csvDownloadPercent, setCsvDownloadPercent] = useState(0);
  
  //Uploading Account/Product
  const [showUploadStatusDialog,setShowUploadStatusDialog] = useState(false)
  const [uploadStatusArray,setUploadStatusArray] = useState([])

  //Account Assignments 
  const [showAssignAccountsDialog, setShowAssignAccountsDialog] = useState(false);
  const [assignAccountsCsvFile, setAssignAccountsCsvFile] = useState("");

  const [accountsAssigned, setAccountsAssigned] = useState([]);
  const [showAccountsDialog, setShowAccountsDialog] = useState(false);

  //Product Assignments 
  const [showAssignProductsDialog, setShowAssignProductsDialog] = useState(false);
  const [assignProductsCsvFile, setAssignProductsCsvFile] = useState("");

  const [productsAssigned, setProductsAssigned] = useState([]);
  const [showProductsDialog, setShowProductsDialog] = useState(false);

  
  //Dialog Message
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [showMessageDialog, setShowMessageDialog] = useState(false);

  const [pricingInfoAnchorElement,setPricingInfoAnchorElement] = useState(null)

  const [selecedPricingScheme,setSelectedPricingScheme] = useState(null)


  // labels
  const [accountsLabel, setAccountLabel] = useState({});
  const [isLoadingAccountLabel, setIsLoadingAccountLabel] = useState(true);

  
    
  useEffect(() => {

    if (!isLoadingAccountLabel) {
      return
    }

    const getAccountsLabel = () => {
      const options = {
        method: 'POST',
        url: '/TransactiLabels/getTransactiLiteLabels.json',
      }

      axios(options)
      .then((res) => {
        
        const labels = res.data.response;
        const accountLabel = labels.accounts
        const accountClassificationsLabel = labels.account_classifications

        setAccountLabel(accountLabel)
        setIsLoadingAccountLabel(false)
      })
      .catch(error => {
        console.log(error)
      })
    }

    getAccountsLabel()
  }, [accountsLabel, isLoadingAccountLabel])

  
  const onInputChangeAccounts = (event) =>{
    let file = event.target.files;
    setAssignAccountsCsvFile(file);
  };

  const onInputChangeProducts = (event) =>{
    let file = event.target.files;
    setAssignProductsCsvFile(file);
  };

  const [newCode, setNewCode] = useState("");
  const [newName, setNewName] = useState("");
  const [setAnchorEl] = useState(null);
  const lastSchemeElementObserver = useRef()
  const lastSchemeElement = useCallback(node=>{
    if(isLoading){
        return
    }
    if(lastSchemeElementObserver.current){
      lastSchemeElementObserver.current.disconnect()
    }
    lastSchemeElementObserver.current = new IntersectionObserver(entries=>{
      if(entries[0].isIntersecting && hasMoreSchemeToLoad){
        
        lastSchemeElementObserver.current.disconnect()
        setPageNumber(prevPageNumber => prevPageNumber + 1)
        setLoadSchemes(true)
      }

    })
    
    if(node){
      lastSchemeElementObserver.current.observe(node)
    }
  },[isLoading, hasMoreSchemeToLoad])

  const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if(!loadSchemes){
      return
    }
    setAppBarWidth(elementRef.current.getBoundingClientRect().width);
    fetchSchemes(searchSchemeTerm.name) 
  },[loadSchemes,searchSchemeTerm.name]); // eslint-disable-line react-hooks/exhaustive-deps

  const objectToFormData = (object) => Object.keys(object).reduce((formData, key) => {
    formData.append(key, object[key]);
    return formData;
  }, new FormData());

  function autoComplete(){
    return (
      <Autocomplete
            value={searchSchemeTerm} noOptionsText={autoCompleteSearchOptionMessage}
            onChange={(event, newValue) => {
              
            
              if(newValue==null || newValue.name===""){
                searchSchemeTerm.name = ""
                return
              }
              searchSchemeTerm.name = newValue.name
              setSchemes([])
              setPageNumber(1)
              setLoadSchemes(true)
            }}
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            options={autoSuggestSchemes}
            isOptionEqualToValue={(option, value) =>true}
            getOptionLabel={(option) => {
              return option.name;
            }}
            renderOption={(props, option) => {
              return (
                <li {...props} key={option.name}>
                  {option.name}
                </li>
              );
            }}
            style={{ width: '100%',paddingLeft:'8px'}}
            renderInput={(params) => (
              <TextField
                {...params}
                variant='standard'  
                InputProps={{...params.InputProps, disableUnderline: true}}  
                
              onChange={(event)=>{ 
                setSearchSchemeTerm({name:event.target.value})
              }
              } />
            )}
          />
    );
  }
  
  useEffect(()=>{

    function fetchAutoSuggestSchemes(searchString){
  
      const loadSchemes = async () => {
          
          setAutoCompleteSearchOptionMessage("Searching")
  
          const options = {
            method: 'POST',
            url: '/TransactiLiteMultipleAccountPricings/getSchemesForAutoSuggest.json',
            data: objectToFormData({search_term:searchString})
          }
            await axios(options)
            .then(res => {
              const schemes = res.data.schemes
              if(schemes.length <= 0){
                setAutoCompleteSearchOptionMessage("No record found.")
                setAutoSuggestSchemes([])
              }else{
                setAutoSuggestSchemes(schemes)
              }
              
            });
        }
        loadSchemes()
    }

    if(searchSchemeTerm == null){
      
      fetchAutoSuggestSchemes("")
    }else{
      fetchAutoSuggestSchemes(searchSchemeTerm.name)
    }
    
  },[searchSchemeTerm]);
  
  function fetchSchemes(searchTerm){
    setIsLoading(true)
    setHasErrorFetchingSchemes(false)

    const options = {
      method: 'POST',
      url: '/TransactiLiteMultipleAccountPricings/getPricingSchemes.json',
      data: objectToFormData({search_term:searchTerm,page_number:pageNumber})
    }

    axios(options)
    .then(res => {

      
    setIsLoading(false)
    setLoadSchemes(false)
    
    const isSuccess = res.data.response.is_success
    if(!isSuccess){
      setMessageDialogMessage(res.data.response.message)
      setShowMessageDialog(true)
      setHasErrorFetchingSchemes(true)
    }

    const schemesFromServer = res.data.response.schemes
    setHasMoreSchemeToLoad(schemesFromServer.length > 0)
    setSchemes(schemes.concat(schemesFromServer))
    
    }).catch(error => {
      setIsLoading(false)
    })
  } 

  function createMultipleAccountPricings(){
    return (
        <div style={{padding:'.1em'}}><br/>   
          <Grid container spacing={12}>
              <Grid item  style={{display:'inline-grid'}}>
                <Typography variant="h5" sx={{fontWeight : 'bold'}}><span>Create Pricing Scheme</span></Typography>
              </Grid>
          </Grid>
          <br/>
          <Grid container spacing={2} >
              
              <Grid item xs={11.5} md={12} >
                  <TextField id="pricing_code" onChange={(e) => {setNewCode(e.target.value.trim())}}  color="info" style={{width:'100%'}} InputLabelProps={{ shrink: true}} autoComplete='off' label="Pricing scheme code" variant="outlined" required/>
              </Grid>
            
              <Grid item xs={11.5} md={12} >
                  <TextField id="pricing_name" onChange={(event) => {setNewName(event.target.value.trim())}} color="info" style={{width:'100%'}} InputLabelProps={{ shrink: true}} autoComplete='off' label="Pricing scheme Name" variant="outlined" required/>
              </Grid>
          </Grid>
          <Grid  spacing={2}>
            <Grid item xs={5} md={5} style={{marginTop:'.5em'}}>
                  <Button variant="contained" color="primary" onClick={saveMultipleAccountPricing}>Create</Button>
              </Grid>
          </Grid>
          <br/><hr/>
        </div>
    )
  }

  function search(){
    return (
      <div style={{padding:'1em'}}>
      <div position="static" style={{border:".1rem solid #989898",borderRadius:"4px"}}>
          <Toolbar variant="dense" style={{padding:'0'}}>
              <Box flexGrow={1}>{autoComplete()}</Box>
              <Box>
              <IconButton 
                className={classes.margin} 
                size="large"
                onClick={()=>{
                  setSchemes([])
                  setPageNumber(1)
                  setLoadSchemes(true)
                }}>
              <SearchIcon />
              </IconButton>
              </Box>
          </Toolbar>
      </div>
      </div>
    );
  }
  
  //Backend Requests
  function saveMultipleAccountPricing(){

    if(newCode === "" || newName === ""){
      setMessageDialogMessage('Scheme Code and name is Required!');
      setShowMessageDialog(true);
    }else{
      axios({
        method: 'POST',
        url: '/TransactiLiteMultipleAccountPricings/savePricingScheme.json',
        data : objectToFormData({code:newCode,name:newName})
      }).then((res) =>{
        console.log(res)
        if(res.data['response']['message'] === 'success'){
          setMessageDialogMessage('Pricing Scheme Successfully Created!');
          setShowMessageDialog(true);
          setHasMoreSchemeToLoad(true)
          setSchemes(schemes.concat(res.data['response'].record))
        }else{
          setMessageDialogMessage(res.data['response']['message']);
          setShowMessageDialog(true);
        }
      });
    }
  } 

  function uploadAccountAssignments(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showAssignAccountsDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Assign {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural}</DialogTitle>
        <DialogContent>
          <Box component="div" p={1} display="grid" flexDirection="column"><i>
            1. File type must be CSV <br/>
            2. Pricing Scheme Code, {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} Code and Branch Code are required</i> <br/>
            <input accept=".csv" type="file" onChange={onInputChangeAccounts} />
          </Box>
          <Box component="div" p={1} sx={{color:"yellow"}}>
            <Button variant="contained" onClick={() => {downloadTemplate('accounts')}}>Download Template</Button>
            <Button variant="contained" onClick={() => {countTemplateAssignments()}} sx={{ml:"5px"}}>Download Template With Assignments</Button>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="info" onClick={() => {processUploadAssignmentsCsv(assignAccountsCsvFile, 'accounts')}}><FileUploadIcon /> Upload</Button>
          <Button variant="contained" onClick={()=>{setShowAssignAccountsDialog(false)}} color="info" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  function uploadProductAssignments(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showAssignProductsDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Assign Products</DialogTitle>
        <DialogContent>
          <Box component="div" p={1} display="grid" flexDirection="column"><i>
            1. File type must be CSV <br/>
            2. Pricing Scheme Code and Product Code are required</i> <br/>
            <input accept=".csv" type="file" onChange={onInputChangeProducts} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => {downloadTemplate('products')}}>Download Template</Button>
          <Button variant="contained" color="info" onClick={() => {processUploadAssignmentsCsv(assignProductsCsvFile, 'products')}}><FileUploadIcon /> Upload</Button>
          <Button variant="contained" onClick={()=>{setShowAssignProductsDialog(false)}} color="info" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  async function countTemplateAssignments(){
    setIsLoading(true)
    const options = {
      method: 'POST',
      url: '/TransactiLiteMultipleAccountPricings/getCsvAssignmentsCount.json',
    }
    await axios(options)
    .then(res => {
      setIsLoading(false)
      setShowAssignAccountsDialog(false)
      let count = res.data.response.count
      let limit = 20;
      if(!count > 0){
        setMessageDialogMessage('No Assignments Found')
        setShowMessageDialog(true)
      }else{
        setShowCsvDownloadAssignments(true);
        const total_count = Math.ceil(count / limit);
        downloadProducts(0,total_count,'');
      }

    }).catch(error => {
      setIsLoading(false)
    })
  } 

  async function downloadProducts(index,total_count,downloadCsvContent){
    let percent = (index / total_count) * 100;
    setCsvDownloadPercent(percent);
    if(index < total_count){
      await axios({
        method: 'POST',
        url: '/TransactiLiteMultipleAccountPricings/getCsvAssignments.json',
        data: objectToFormData({index:index})
      })
      .then(res => {
        let scheme_assignments = res.data.response.schemes_array;
        scheme_assignments.forEach(scheme => {
          downloadCsvContent += scheme.code+','+scheme.name+','+scheme.account_code+','+scheme.account_name+','+scheme.branch_code+','+scheme.branch_name;
          downloadCsvContent += '\n\n';
        });
      });
      downloadProducts(index+1,total_count,downloadCsvContent);
    }else{
      let header = 'Pricing Scheme Code*,Pricing Scheme Name,'+Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural+' Code*,'+Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural+' Name,Branch Code*,Branch Name';
      let csv = header+'\n\n'+downloadCsvContent;
      const url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'Scheme ' + Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural + ' Assignments.csv')
      document.body.appendChild(link)
      link.click()
      link.remove()
      setCsvDownloadPercent(0);
      setShowCsvDownloadAssignments(false);
    }
  }

  function messageDialog(){
    return(
     
      <Dialog
      fullWidth={true}
      maxWidth={'sm'}
      open={showMessageDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
         {messageDialogMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{setShowMessageDialog(false)}} color="primary" autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
    )
  }

  function csvDownloadTemplateAssignmentsDialog(){
    return(
      <Dialog 
      fullWidth={true}
      maxWidth={'md'}
      open={showCsvDownloadAssignments}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">CSV Download</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <LinearProgress variant="determinate" value={csvDownloadPercent} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    )
  }

  function downloadTemplate(type){
    let header = '';
    let csv_name = type

    if(type === 'accounts'){
      csv_name = Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural
      header = 'Pricing Scheme Code*,Pricing Scheme Name,'  + Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural + ' Code*, '  + Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural + ' Name,Branch Code*, Branch Name';
    }else{
      header = 'Pricing Scheme Code*,'  + Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural + ' Code*,Product Uom*,List Price with Tax*,List Price without Tax*';
    }

    const url = 'data:text/csv;charset=utf-8,' + encodeURIComponent(header);
    const link = document.createElement('a')
    link.href = url;
    link.setAttribute('download', `Upload `+csv_name+`.csv`);
    document.body.appendChild(link)
    link.click()
    link.remove()
  }

  function processUploadAssignmentsCsv(csvFile, type){
    let file = csvFile[0];
    let headersChecked = false; 
    if(file !== undefined && file.type === "text/csv"){
      Papa.parse(file, {
        header: true,
        skipEmptyLines : true,
        complete: function(results) {
          if(!headersChecked){
            let keys = [];
            Object.keys(results.data[0]).forEach(value =>{
              keys.push(value);
            });
            
            let type_condition = '';
            if(type === 'accounts'){
              type_condition = keys.includes(('Pricing Scheme Code*')) || keys.includes('Pricing Scheme Name') || keys.includes(Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural+' Code*') || keys.includes(Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural+' Name')  || keys.includes('Branch Code*') || keys.includes('Branch Name');
            }else{
              type_condition = keys.includes(('Pricing Scheme Code*')) || keys.includes('Product Code*') || keys.includes('Product Uom*') || keys.includes('List Price with Tax*') || keys.includes('List Price with Tax*');
            }
            
            if(type_condition) {
                  headersChecked = true;
            } else{
                alert('File Error. Please Check your headers');
            }
          }if(headersChecked){
            let chunkedData = chunkUploadData(results.data);
            if(chunkedData.length > 0){

              if(type === 'accounts'){
                setShowAssignAccountsDialog(false);
              }else{
                setShowAssignProductsDialog(false);
              }
              uploadAssignments(0,chunkedData, type);
              setShowUploadStatusDialog(true);
            }else{
              alert('No data to upload');
            }
          }
        }
      });
    }else{
      alert('File error. Please check your file or if a file was selected.');
    }
  }

  async function uploadAssignments(index, chunkedData, type){
    
    let url = '';
    if(type === 'accounts'){
      url = '/TransactiLiteMultipleAccountPricings/uploadAccountAssignments.json';
    }else{
      url = '/TransactiLiteMultipleAccountPricings/uploadProductsAssignments.json';
    } 
    if(index < chunkedData.length){
      var data = JSON.stringify(chunkedData[index]);
      await axios({
        method: 'POST',
        url: url,
        data: objectToFormData({index:index, data:data})
      }).then((res) =>{
        let res_status = res.data;
        setUploadStatusArray(uploadStatusArray => [...uploadStatusArray, ...res_status]);
      });
      uploadAssignments(index+1, chunkedData);
    }
  }

  function chunkUploadData(results){
    let chunkedData = [];
    let dataArray = [];
    for(let i = 0; i < results.length; i++){
      if(dataArray.length === 10){
        chunkedData.push(dataArray);
        dataArray = [];
      }

      dataArray.push(results[i]);
   
      if ( i === results.length - 1 )
      {
        chunkedData.push(dataArray);
        dataArray = [];
      }
    }
    return chunkedData;
  }
  
  function uploadStatusDialog(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showUploadStatusDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>Upload Assignments</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left"><b>Line</b></TableCell>
                  <TableCell><b>Message</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index)=> (
                    <TableRow key={index}>  
                      <TableCell align="left" component="th" scope="row"><b>{index+1}</b></TableCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{closeUploadStatusDialog()}} color="primary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  function closeUploadStatusDialog(){
    setSchemes([])
    setPageNumber(1)
    setLoadSchemes(true)
    setShowUploadStatusDialog(false);
    setUploadStatusArray([]);
  }


  function displayScheme(code,name,product_count,account_count){
    return(
      <>
        <Box p={1}>
          <Typography variant="h5"><small>{name}</small></Typography>
          <Typography variant="h6"><small><b>{code}</b></small></Typography>
        </Box>
        <Button variant="contained" onClick={() => viewAccounts(code)} color="info" sx={{mt:'15px',ml:'auto !important'}}>View Accounts &nbsp;(<b>{account_count}</b>)</Button> 
        <Button variant="contained" onClick={() => viewProducts(code)} color="info" sx={{mt:'15px', ml:'5px'}}>View Products &nbsp;(<b>{product_count}</b>)</Button> 
      </>
    )
  }

  async function viewAccounts(code){
    await axios({
      method: 'POST',
      url: '/TransactiLiteMultipleAccountPricings/accountAssignmentsTable.json',
      data: objectToFormData({code:code})
    })
    .then(res => {
      if(res.data.response.accounts.length > 0){
        setAccountsAssigned(res.data.response.accounts);
        setShowAccountsDialog(true);
      }else{
        setMessageDialogMessage('No accounts assigned!');
        setShowMessageDialog(true);
      }
    });
  }

  async function viewProducts(code){
    await axios({
      method: 'POST',
      url: '/TransactiLiteMultipleAccountPricings/productsAssignmentsTable.json',
      data: objectToFormData({code:code})
    })
    .then(res => {
      if(res.data.response.products.length > 0){
        setProductsAssigned(res.data.response.products);
        setShowProductsDialog(true);
      }else{
        setMessageDialogMessage('No products assigned!');
        setShowMessageDialog(true);
      }
    });
  }

  function AccountsDialog(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showAccountsDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>View Accounts Assigned</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="accounts_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left"><b>{Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} Code</b></TableCell>
                  <TableCell><b>{Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} Name</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {accountsAssigned.map((value, index)=> (
                    <TableRow key={index}>  
                      <TableCell>{value.account_code}</TableCell>
                      <TableCell>{value.account_name}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{closeAccountsDialog()}} color="primary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  function ProductsDialog(){
    return(
      <Dialog fullWidth={true} maxWidth={'md'} open={showProductsDialog} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle>View Products Assigned</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="products_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left"><b>Product Code</b></TableCell>
                  <TableCell><b>Product Name</b></TableCell>
                  <TableCell><b>Product UOM</b></TableCell>
                  <TableCell><b>List Price with Tax</b></TableCell>
                  <TableCell><b>List Price without Tax</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productsAssigned.map((value, index)=> (
                    <TableRow key={index}>  
                      <TableCell>{value.code}</TableCell>
                      <TableCell>{value.name}</TableCell>
                      <TableCell>{value.uom}</TableCell>
                      <TableCell>{value.lp_with_tax}</TableCell>
                      <TableCell>{value.lp_without_tax}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{closeProductsDialog()}} color="primary" autoFocus>Close</Button>
        </DialogActions>
      </Dialog>
    )
  }

  function closeAccountsDialog(){
    setAccountsAssigned([])
    setShowAccountsDialog(false);
  }

  function closeProductsDialog(){
    setProductsAssigned([])
    setShowProductsDialog(false);
  }

  function searchByDropdownMenu(){
    return(
      <Menu
      id="simple-menu"
      anchorEl={pricingInfoAnchorElement}
      keepMounted
      open={Boolean(pricingInfoAnchorElement)}
      onClose={()=>{setPricingInfoAnchorElement(null)}}
      >
        <MenuItem 
            onClick={()=>{
              viewAccounts(selecedPricingScheme.pricing_scheme_code)
             }} >
            View accounts ({selecedPricingScheme ? selecedPricingScheme.accounts_count : ""})
            </MenuItem>
            <MenuItem 
            onClick={()=>{ 
              viewProducts(selecedPricingScheme.pricing_scheme_code)
              }
            } >
            View products ({selecedPricingScheme ? selecedPricingScheme.products_count : ""})
            </MenuItem>
      </Menu>
    )
}


  function schemeLists(){
    return(
      <div style={{padding:'.1em'}}>
     
        <Grid container>
          <Grid item sm={12} style={{display:'inline-grid',justifyItems: 'left'}}>
            <Typography variant="h5" sx={{fontWeight : 'bold'}}><span>Pricing Schemes</span></Typography>
          </Grid>  
        </Grid>
        <Container maxWidth="xl">
          {
            schemes.map((scheme,index)=>(
                (schemes.length  === index + 1) ?
                ( 
                  <React.Fragment key={index+scheme.id+scheme.pricing_scheme_name} >
                    <ListItem ref={lastSchemeElement} key={index+scheme.id+scheme.pricing_scheme_name} divider 
                        
                    >
                    <ListItemText primary={scheme.pricing_scheme_name} secondary={scheme.pricing_scheme_code} />
                    {/*displayScheme(scheme.pricing_scheme_code, scheme.pricing_scheme_name,scheme.products_count,scheme.accounts_count)*/}
                    
                      <IconButton size="large" 
                        onClick={
                            (event)=>{
                              setSelectedPricingScheme(scheme)
                              setPricingInfoAnchorElement(event.currentTarget)
                              }
                            }>
                        <MoreVertIcon />
                      </IconButton>
                      
                    </ListItem>
                  </React.Fragment>
                )
                :
                (
                  <React.Fragment key={index+scheme.id+scheme.pricing_scheme_name}>
                    <ListItem key={index+scheme.id+scheme.pricing_scheme_name} divider 
                      
                    >
                    {/*displayScheme(scheme.pricing_scheme_code, scheme.pricing_scheme_name,scheme.products_count,scheme.accounts_count)*/}
                    <ListItemText primary={scheme.pricing_scheme_name} secondary={scheme.pricing_scheme_code} />
                    {/*displayScheme(scheme.pricing_scheme_code, scheme.pricing_scheme_name,scheme.products_count,scheme.accounts_count)*/}
                    
                      <IconButton size="large" onClick={
                          (event)=>{
                            setSelectedPricingScheme(scheme)
                            setPricingInfoAnchorElement(event.currentTarget)
                          }
                        }>
                        <MoreVertIcon />
                      </IconButton>
                    </ListItem>
                </React.Fragment>
                )
              )
            )
          }
        </Container>
      </div>
    )
  }

  return (
      <React.Fragment>
     
      <div>
              <CssBaseline />
              <AppBar position="fixed" className={classes.appBarTop} aria-haspopup="true" onClick={handleClick} ref={elementRef}>
                  <Toolbar>
                  <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={props.handleDrawerToggle}
                    className={classes.menuButton}
                    size="large">
                      <MenuIcon />
                  </IconButton>
                  <Typography variant="h6" noWrap>
                      Multiple {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural} Pricings
                  </Typography>
                  </Toolbar>
              </AppBar>
          </div>
        <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
        {isLoading ? <LinearProgress color="secondary"  style={{marginLeft:'.1rem',marginRight:'.1rem'}}/> : ''}
        </AppBar>

        <div >
          {createMultipleAccountPricings()}
          {search()}
          {schemeLists()}
          {searchByDropdownMenu()}
          <br/><br/><br/>
          <AppBar position="fixed"  style={{ background: 'transparent', boxShadow: 'none'}} className={classes.appBarBottom}>
              <Toolbar>
                <div className={classes.grow} />
                <Fab variant="extended" size="medium" 
                color="primary" aria-label="add" className={classes.margin}
                onClick={()=>{setShowAssignProductsDialog(true)} }>
                  <CreateIcon className={classes.extendedIcon} />
                  Assign Products
                </Fab>
                <Fab variant="extended" size="medium"
                  color="primary" aria-label="add" 
                  className={classes.margin} sx={{ml : '5px'}}
                  onClick={()=>{setShowAssignAccountsDialog(true)}}
                >
                  <CreateIcon className={classes.extendedIcon} />Assign {Object.keys(accountsLabel).length === 0 ? "Accounts" : accountsLabel.plural}
                </Fab>
              </Toolbar>
          </AppBar>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={materialTheme}> {csvDownloadTemplateAssignmentsDialog()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {uploadProductAssignments()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {uploadAccountAssignments()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {uploadStatusDialog()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {AccountsDialog()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {ProductsDialog()}</ThemeProvider>
            <ThemeProvider theme={materialTheme}> {messageDialog()}</ThemeProvider>
          </StyledEngineProvider>
        </div>

      </React.Fragment>
  );
}

export default MultipleAccountPricings